"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.findSystemExchangeProjects = exports["default"] = exports.SegmentDetails = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _request = require("@nicbase/request");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var findSystemExchangeProjects = function findSystemExchangeProjects(portalId) {
  return {
    type: 'FIND_SYSTEM_EXCHANGE_PROJECTS_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {}
  };
};

exports.findSystemExchangeProjects = findSystemExchangeProjects;

var mapStateToProps = function mapStateToProps(state) {
  return {
    alarms: state.informationLists.alarms
  };
};

exports.mapStateToProps = mapStateToProps;

var SegmentDetails = function SegmentDetails(_ref) {
  var alarms = _ref.alarms,
      tour = _ref.tour;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _usePermissions = (0, _nicbaseSecurity.usePermissions)('PORTAL'),
      hasPermissions = _usePermissions.hasPermissions;

  var _useQuery = (0, _reactQuery.useQuery)([].concat(_toConsumableArray(_hooks.queryKeys.portal.all(portalId)), ['systemExchangeProjects']), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, projects;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(findSystemExchangeProjects(portalId));

          case 2:
            _yield$request = _context.sent;
            projects = _yield$request.body.projects;
            return _context.abrupt("return", projects);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), {
    enabled: hasPermissions(['module.dcc.systemexchange.read'])
  }),
      _useQuery$data = _useQuery.data,
      systemExchangeProjects = _useQuery$data === void 0 ? [] : _useQuery$data;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, tour.segments.map(function (segment, index) {
    var _tour$wayPoints$start, _tour$wayPoints$endPo;

    var externalId = segment.externalId,
        _segment$validityWayP = segment.validityWayPointIndexRange,
        validityWayPointIndexRange = _segment$validityWayP === void 0 ? [] : _segment$validityWayP,
        _segment$emailRecipie = segment.emailRecipients,
        emailRecipients = _segment$emailRecipie === void 0 ? [] : _segment$emailRecipie,
        smsRecipients = segment.smsRecipients,
        _segment$alarms = segment.alarms,
        segmentAlarms = _segment$alarms === void 0 ? [] : _segment$alarms,
        _segment$projects = segment.projects,
        projects = _segment$projects === void 0 ? [] : _segment$projects,
        report = segment.report;

    var _ref3 = report !== null && report !== void 0 ? report : {},
        _ref3$recipients = _ref3.recipients,
        recipients = _ref3$recipients === void 0 ? [] : _ref3$recipients,
        _ref3$showGeoInformat = _ref3.showGeoInformation,
        showGeoInformation = _ref3$showGeoInformat === void 0 ? false : _ref3$showGeoInformat,
        _ref3$shareViaEmail = _ref3.shareViaEmail,
        shareViaEmail = _ref3$shareViaEmail === void 0 ? true : _ref3$shareViaEmail,
        _ref3$uploadAsIdocFor = _ref3.uploadAsIdocFormat,
        uploadAsIdocFormat = _ref3$uploadAsIdocFor === void 0 ? false : _ref3$uploadAsIdocFor;

    var startPoiIndex = validityWayPointIndexRange[0];
    var endPoiIndex = validityWayPointIndexRange[validityWayPointIndexRange.length - 1];
    var intermediatePoiIndices = validityWayPointIndexRange.filter(function (_, wayPointIndex) {
      return wayPointIndex !== 0 && wayPointIndex !== validityWayPointIndexRange.length - 1;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col mb-3"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold mb-1 text-base text-primary"
    }, "Segment ", index + 1), externalId ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.externalId"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, externalId)) : null, Number.isInteger(startPoiIndex) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.from"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, (_tour$wayPoints$start = tour.wayPoints[startPoiIndex]) === null || _tour$wayPoints$start === void 0 ? void 0 : _tour$wayPoints$start.poiName)), intermediatePoiIndices.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.via"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, intermediatePoiIndices.map(function (wayPointIndex) {
      var _tour$wayPoints$wayPo;

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "intermediateWaypoint-".concat(wayPointIndex)
      }, (_tour$wayPoints$wayPo = tour.wayPoints[wayPointIndex]) === null || _tour$wayPoints$wayPo === void 0 ? void 0 : _tour$wayPoints$wayPo.poiName);
    }))), Number.isInteger(endPoiIndex) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.to"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, (_tour$wayPoints$endPo = tour.wayPoints[endPoiIndex]) === null || _tour$wayPoints$endPo === void 0 ? void 0 : _tour$wayPoints$endPo.poiName)), projects.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.projects"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col"
    }, projects.map(function (segmentProject) {
      var _systemExchangeProjec;

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: segmentProject,
        className: "flex mb-1 last:mb-0 mr-2"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-col"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "underline"
      }, (_systemExchangeProjec = systemExchangeProjects.find(function (project) {
        return project.id === Number(segmentProject.id);
      })) === null || _systemExchangeProjec === void 0 ? void 0 : _systemExchangeProjec.projectName), (segmentProject === null || segmentProject === void 0 ? void 0 : segmentProject.tourProperties) && Object.entries(segmentProject.tourProperties).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "font-bold mr-1"
        }, key, ":"), /*#__PURE__*/_react["default"].createElement("span", null, value));
      })));
    }))) : null, segmentAlarms.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink- truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.alarms"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, segmentAlarms.map(function (alarmId) {
      var _alarms$find;

      return /*#__PURE__*/_react["default"].createElement("div", null, (_alarms$find = alarms.find(function (alarm) {
        return alarm.id === alarmId;
      })) === null || _alarms$find === void 0 ? void 0 : _alarms$find.name);
    }))) : null, emailRecipients.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.emailRecipients"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, emailRecipients.map(function (recipient) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        email: "sms-".concat(recipient.recipient)
      }, recipient.recipient);
    }))) : null, smsRecipients.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start mb-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.smsRecipients"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, smsRecipients.map(function (recipient) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "sms-".concat(recipient.recipient)
      }, recipient.recipient);
    }))) : null, recipients.length > 0 || !shareViaEmail ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-start"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-20 mr-1 flex-shrink-0 truncate"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourboard.details.segments.reportRecipients"
    }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, recipients.map(function (recipient) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "report-".concat(recipient)
      }, recipient);
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "underline"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: showGeoInformation ? 'widgets.tourBoard.withPositionInformation' : 'widgets.tourBoard.withoutPositionInformation'
    })), !shareViaEmail ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "underline"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.uploadReportDetail"
    })) : null, !shareViaEmail && uploadAsIdocFormat ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "underline"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.Idoc"
    })) : null)) : null);
  }));
};

exports.SegmentDetails = SegmentDetails;
SegmentDetails.propTypes = {
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  tour: _propTypes["default"].shape({
    segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      externalId: _propTypes["default"].string,
      validityWayPointIndexRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
      projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      alarms: _propTypes["default"].arrayOf(_propTypes["default"].number),
      emailRecipients: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
      smsRecipients: _propTypes["default"].arrayOf(_propTypes["default"].shape())
    })),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      poiId: _propTypes["default"].string,
      poiName: _propTypes["default"].string,
      frontendId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    }))
  }).isRequired
};
SegmentDetails.defaultProps = {
  alarms: []
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SegmentDetails);

exports["default"] = _default;